import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import {  Router } from '@angular/router';
import { ProfileService } from 'src/app/shared/services/profile.service';
import { CommonFunctions } from 'src/app/shared/common-functions';
import { AuthenticationService } from 'src/app/shared/services/authentication.service';
import { ViewCartService } from 'src/app/shared/services/view-cart.service';
import { EncryptDecryptService } from 'src/app/core/services/encrypt-decrypt.service';
import { Title } from '@angular/platform-browser';
import { CmsService } from 'src/app/shared/services/cms.service';
import { StorageService } from 'src/app/shared/services/storage.service';
declare var dataLayer;
@Component({
  selector: 'app-user-profile',
  templateUrl: './user-profile.component.html',
  styleUrls: ['./user-profile.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class UserProfileComponent implements OnInit {
  public breadCrumbData: Array<Object> = [
    { title: 'Profile', path: 'profile' },
    { title: 'Account' }];
  public tierType: string = 'welcome';
  public isLoggedIn: boolean = false;
  public viewData: any;
  public imageUrl: any = "assets/images/profileDP.svg";
  public isLoggedInUser: boolean = false;
  public profileItems = [];
  public isMobileDevice: boolean;
  public title: string = 'Profile | Tata Starbucks';
  public userType: string;
  public userId: any;
  public footerContent: any;
  public isMobile: boolean;
  public showProfileShimmer:boolean;
  constructor(
    public router: Router,
    private profile: ProfileService,
    private auth: AuthenticationService,
    private viewCartService: ViewCartService,
    private encryptDecryptService: EncryptDecryptService,
    private commonFunction: CommonFunctions,
    private storageService:StorageService,
    private cmsService: CmsService,
    private titleService: Title) {
    this.isLoggedInUser = this.commonFunction.verifyLoggedInUser();
    let user_profile = localStorage.getItem('user_profile');
    if (this.isLoggedInUser && user_profile != null) {
      this.viewProfileData();
    }
    this.assignProfileItems();
    this.isMobile = this.commonFunction.identifyDeviceType();
    this.titleService.setTitle(this.title);
    this.userType = this.commonFunction.getUserType();
    this.userId = this.commonFunction.getUserId();
    // if (localStorage.getItem('footerCategoriesData') != null) {
    //   this.footerContent = JSON.parse(localStorage.getItem('footerCategoriesData'))
    // } else {
    //   this.getFooterContent();
    // }
  }
  ngOnInit(): void {
    sessionStorage.removeItem('activeMenu');
    sessionStorage.removeItem('activeId');
    this.profilePageGA();
  }
  public viewProfile(): void {
    this.commonFunction.showLoader();
    this.profile.viewProfile().subscribe((res) => {
      this.viewData = res['response'];
      this.viewData.tier = res['response'].tier != null ? this.encryptDecryptService.decryptData(res['response'].tier) : 'welcome';
      this.viewData.mobileNumber = res['response'].mobileNumber != null ? this.encryptDecryptService.decryptData(res['response'].mobileNumber) : '';
      this.viewData.emailId = res['response'].emailId != null ? this.encryptDecryptService.decryptData(res['response'].emailId) : '';
      this.viewData.dateOfBirth = res['response'].dateOfBirth != null ? this.encryptDecryptService.decryptData(res['response'].dateOfBirth) : '';
      this.viewData.starBalance = res['response'].starBalance != null ? this.encryptDecryptService.decryptData(res['response'].starBalance) : 0;
      this.viewData.starEarned = res['response'].starEarned != null ? this.encryptDecryptService.decryptData(res['response'].starEarned) : 0;
      this.viewData.currentStarBalance = res['response'].currentStarBalance != null ? this.encryptDecryptService.decryptData(res['response'].currentStarBalance) : 0;
      this.viewData.tierUpperLimit = res['response'].tierUpperLimit != null ? this.encryptDecryptService.decryptData(res['response'].tierUpperLimit) : 0;
      this.viewData.anniverSaryDate = res['response'].anniverSaryDate != null ? this.encryptDecryptService.decryptData(res['response'].anniverSaryDate) : '';
      this.viewData.rewardCount = res['response'].rewardCount != null ? this.encryptDecryptService.decryptData(res['response'].rewardCount) : 0;
      this.viewData.totalCardBalance = res['response'].totalCardBalance != null ? this.encryptDecryptService.decryptData(res['response'].totalCardBalance) : 0;
      this.viewData.totalMsrCardBalance = res['response'].totalMsrCardBalance != null ? this.encryptDecryptService.decryptData(res['response'].totalMsrCardBalance) : 0;
      if (this.viewData['profileImage'] != '' && this.viewData['profileImage'] != null) {
        this.imageUrl = this.encryptDecryptService.decryptData(this.viewData['profileImage']);
      }
      this.tierType = this.viewData.tier != '' ? this.viewData.tier.toLowerCase() : 'welcome';
      let userData = JSON.parse(localStorage.getItem('user_profile'));
      userData['enableEmail'] = this.viewData['enableEmail'];
      userData['enableSMS'] = this.viewData['enableSMS'];
      localStorage.setItem("user_profile", JSON.stringify(userData));
      this.commonFunction.hideLoader();
    }, (error: any) => {
      this.commonFunction.hideLoader();
      if (error.error.status == 400 || error.error.status == 401 || error.error.status == 500) {
        this.commonFunction.displaySnackBarMessage(error.error.response[0], 'failure');
      }
    })
  }
  /**
  * Method to get profile data
  */
  public viewProfileData(): void{
    this.showProfileShimmer=true;
    this.profile.viewProfile().subscribe((res) => {
      this.showProfileShimmer=false;
      this.viewData = res['response'];
      this.viewData.tier = res['response'].tier != null ? this.encryptDecryptService.decryptData(res['response'].tier) : 'welcome';
      if (this.viewData['profileImage'] != '' && this.viewData['profileImage'] != null) {
        this.imageUrl = this.encryptDecryptService.decryptData(this.viewData['profileImage']);
      }
      this.tierType =this.viewData && this.viewData.tier != '' ? this.viewData.tier.toLowerCase() : 'welcome';
      let userData = JSON.parse(localStorage.getItem('user_profile'));
      userData['enableEmail'] = this.viewData['enableEmail'];
      userData['enableSMS'] = this.viewData['enableSMS'];
      localStorage.setItem("user_profile", JSON.stringify(userData));
    }, (error: any) => {
      this.showProfileShimmer=false;
      if (error.error.status == 400 || error.error.status == 401 || error.error.status == 500) {
        this.commonFunction.displaySnackBarMessage(error.error.response[0], 'failure');
      }
    })
  }
  public assignProfileItems() {
    if (!this.isLoggedInUser) {
      this.profileItems = [{ displayName: "HELP CENTER", iconName: "assets/icon/help_centre.svg", id: 7, routeName: ['/profile/help-center'] }];
    } else {
      this.profileItems = [
        // { displayName: "STARBUCKS REWARDS", iconName: "assets/icon/profile_rewards_star.svg", id: 1, routeName: ['/rewards'] },
        { displayName: "ORDERS", iconName: "assets/icon/orders.svg", id: 2, routeName: ['/ordering/recent-orders-list'] },
        // { displayName: "STARBUCKS PAY", iconName: "assets/icon/starbucks_pay.svg", id: 4, routeName: ['/pay'] },
        // { displayName: "OTHER PAYMENT MODES", iconName: "assets/icon/credit_card.svg", id: 5, routeName: ['/profile/other-payment-modes'] },
        // { displayName: "HELP CENTER", iconName: "assets/icon/help_centre.svg", id: 7, routeName: ['/profile/help-center'] },
        // { displayName: "SAVED ARTICLES & NEWS", iconName: "assets/icon/articles_ico.svg", id: 8, routeName: ['/saved-blogs'] },
      ];
    }
  }
  gotoPrevius(){
    this.router.navigate(['/ordering']);
  }
  public userLogout() {
    this.commonFunction.showLoader();
    let visit =  this.storageService.getVisit()
    this.auth.logout()
    .subscribe((result: any) => {
      this.commonFunction.hideLoader();
      if (result.status == 200) {
        this.commonFunction.clearLogedInUserData();
        this.setPrevVisit(visit);
        this.deleteBasket();
        sessionStorage.setItem('logOut',JSON.stringify(true))
        this.router.navigate(['/ordering']);
      }
    }, (error) => {
      this.commonFunction.hideLoader();
      if (error.error.status == 400 || error.error.status == 401 || error.error.status == 500) {
        this.storageService.removeGuestToken();
        this.storageService.removeRefreshToken();
        this.storageService.removeAccessToken();
       this.router.navigate(['/login']);
      }
    })
  }
  setPrevVisit(visit){
    if(visit){
      this.storageService.setVisit();
    }
  }
  deleteBasket() {
    let basketId = this.storageService.getBasketId();
    if (basketId) {
      let data = {
        'basketId': basketId
      }
      this.viewCartService.deleteBasket(data).subscribe(res => {
        localStorage.removeItem('snackbarData');
        localStorage.removeItem('manualCouponCode');
        this.storageService.clearBasketId();
        sessionStorage.removeItem('finalReqBodyArray');
      })
    }
  }
  public getFooterContent() {
    this.cmsService.getFooterContent().subscribe((response) => {
      this.footerContent = response['response'];
      localStorage.setItem('footerCategoriesData', JSON.stringify(response['response']))
    })
  }
  profileListGA(profilepage){
    profilepage=profilepage.toLowerCase();
    let page=profilepage.split(' ').join('_');
    dataLayer.push({
      'event': 'profile_'+page+'_click',
        'userID':this.userId ,
        'user_type':this.userType,
        'tier': this.viewData && this.viewData.tier ? this.viewData.tier : 'NA'
    })
  }
  notificationGA(){
    dataLayer.push({
      'event': 'profile_page_notification_click',
      'userID':this.userId ,
      'user_type':this.userType,
      'tier': this.viewData && this.viewData.tier ? this.viewData.tier : 'NA'
    })
  }
  settingsGA(){
    dataLayer.push({
      'event': 'profile_page_setting_click',
        'userID':this.userId ,
        'user_type':this.userType,
        'tier': this.viewData && this.viewData.tier ? this.viewData.tier : 'NA'
    })
  }
  logOutGA(){
    dataLayer.push({
      'event': 'profile_page_logout_click',
        'userID':this.userId ,
        'user_type':this.userType,
        'tier': this.viewData && this.viewData.tier ? this.viewData.tier : 'NA'
    })
  }
  editProfileGA(){
    dataLayer.push({
      'event': 'profile_page_edit_click',
        'userID':this.userId ,
        'user_type':this.userType,
        'tier': this.viewData && this.viewData.tier ? this.viewData.tier : 'NA'
    })
  }
  profilePageGA(){
    dataLayer.push({
      'event': 'virtualpageview',
        'page_location': window.location.href,
        'page_title': this.title
    })
  }
}
